import { ng } from '@uirouter/angularjs/lib/angular';
import angular = require('angular');
import _ = require('underscore');
import { PopupService } from '../../../../../../app.common/modules/common/services/popup.service';
import { IProductIngredient } from '../../../../model/products/IProductIngredient';

class ProductIngredientsList implements ng.IController {

    public static $inject = [
        '$translate',
        'popupService',
        '$uibModal',
        '$interpolate'];

    public items: IProductIngredient[];
    public onItemAdd: (item: any) => any;
    public onItemDelete: (item: any) => any;
    public onItemsDelete: (items: any) => any;

    public ingredientsListForm: ng.IFormController & {
        minQuantity: ng.INgModelController
    };

    // public treeOptions = {
    //     accept(sourceNodeScope: any, destNodesScope: any) {
    //         return sourceNodeScope.$modelValue.ItemTypeID === destNodesScope.$modelValue[0].ItemTypeID;
    //     },
    //     dragStart(event: any) {
    //         event.elements.dragging[0].classList.add('drag-item');
    //     },
    //     dropped(event: any) {
    //         event.elements.dragging[0].classList.remove('drag-item');
    //     }
    // };

    public minQuantityErrorList: {[id: string]: string} = {
        required: 'variation_ingredient_max_quantity_required_error',
        parse: 'variation_ingredient_max_quantity_required_error',
        number: 'variation_ingredient_max_quantity_required_error'
    };

    constructor(
        private $translate: angular.translate.ITranslateService,
        private popupService: PopupService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private $interpolate: angular.IInterpolateService
    ) {
    }

    public async deleteIngredient(deleteItem: IProductIngredient) {
        const itemToDeleteIndex = this.items.findIndex((item) => item.ID === deleteItem.ID);
        if (itemToDeleteIndex > -1) {
            this.items.splice(itemToDeleteIndex, 1);
        }
        this.onItemDelete({item: deleteItem});
    }

    public async addIngredient() {
        let operationResult: any;
        try {
            operationResult = await this.$uibModal.open({
                component: 'productSelectIngredients',
                size: 'md',
                resolve: {
                    options: () => {
                        return {
                            selectedIngredients: this.items,
                        };
                    }
                },
                backdrop: 'static',
            }).result;
        } catch (error) {
            return;
        }

        if (operationResult && operationResult.status === 'ok') {
            const selectedItems = operationResult.selectedIngredients as IProductIngredient[];

            const [existItems, newItems] = _(selectedItems).partition((selectedItem) => {
                return this.items.some((item) => item.ID === selectedItem.ID);
            });

            const existIngredients = existItems.map((existItem) => {
                 return this.items.find((item) => item.ID === existItem.ID);
            });

            const newIngredients = newItems.map((item) => {
                const newItem: IProductIngredient = {
                    ID: item.ID,
                    Title: item.Title,
                    MinQuantity: 0
                };
                this.onItemAdd({item: newItem});
                return newItem;
            });

            const destItems =  [...existIngredients, ...newIngredients];

            const itemsToRemove = this.items.filter((item) => {
                return !destItems.find((destItem) => destItem.ID === item.ID);
            });

            if (this.onItemsDelete && itemsToRemove.length > 0) {
                this.onItemsDelete({items: itemsToRemove});
            }
            destItems.sort((a, b) => a.Title.localeCompare(b.Title));

            this.items = destItems;
        }
    }

    public getMinQuantityErrorText() {
        const errorKeys = [this.minQuantityErrorList.parse];
        return this.getErrorString(errorKeys);
    }

    private getErrorString(errorKeys: string[]) {
        const template = '{{ error | translate}}';
        const exp = this.$interpolate(template);
        let resultError = '';
        errorKeys.forEach((key) => {
            resultError += '<i class="fa fa-exclamation-circle mr3"></i>' + exp({ error: key}) + '<br>';
        });
        return resultError;
    }

}

angular.module('naut').component('productIngredientsList', {
    template: require('./product-ingredients-list.component.html'),
    controller: ProductIngredientsList,
    controllerAs: 'ctrl',
    bindings: {
        onItemDelete: '&',
        onItemsDelete: '&',
        onItemAdd: '&',
        isDisabled: '<',
        items: '='
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/shared/product-ingredients-list/product-ingredients-list.component.ts